import {text_mod_60, } from "../text/Text.js";
export const module60 = {
  title:
    "§60. Текст. Ознаки тексту",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_60, },
    ]
  }
